import { HttpParams } from '@angular/common/http';

type QueryParamValue = string | number | boolean | Array<string | number | boolean> | null | undefined;

type CollectionPayload<T> = T[] | { data?: T[]; items?: T[]; rows?: T[]; results?: T[] } | null | undefined;

export function buildHttpParams(paramsObj: Record<string, QueryParamValue> = {}): HttpParams {
  let params = new HttpParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach(v => params = params.append(key, String(v)));
    } else {
      params = params.set(key, String(value));
    }
  });

  return params;
}

export function extractCollection<T>(payload: CollectionPayload<T>): T[] {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  if (Array.isArray(payload.rows)) {
    return payload.rows;
  }

  if (Array.isArray(payload.results)) {
    return payload.results;
  }

  return [];
}
